import Skeleton from "react-loading-skeleton";
import * as styles from "./styles";

export default function Loading() {
    return (
        <div className={styles.container}>
            <div className="hidden flex-col pt-4 md:flex">
            <Skeleton className={styles.mainPanel} count={1} />
            <Skeleton className={styles.panelSkeleton} count={1} />
            </div>
            <div className={styles.rightSideContainer}>
                <Skeleton className={styles.searchSkeleton} />
                <Skeleton className={styles.rightSideElement + " mr-2 w-32"} />
            </div>
            <Skeleton className={styles.panelSkeleton + " md:hidden"} count={4} />
        </div>
    );
}
